import { LocaleEnum } from 'schema/locale';
import { config } from 'shared/config';

export const getCanonicalLink = (slug: string, locale: LocaleEnum) => {
  const localePrefix = locale === LocaleEnum.enUS ? '/' : `/${locale}/`;

  /* Remove slash from end of string */
  const cleanPath = slug.replace(/^\/*/g, '');
  /* Remove slash from start of string */
  const publicUrl = config.NEXT_PUBLIC_AG_URL.replace(/\/*$/g, '');

  return `${publicUrl}${localePrefix}${cleanPath}`.replace(/\/*$/, '');
};
